export enum SortDirection {
  none = 'None',
  asc = 'Asc',
  desc = 'Desc'
}
